













































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { eventTypeMap, currencyMap, permil, changedInvestColumns, dealTypeMap, dateString } from '@/utils/finance';
import { projectListQuery, dealEvent, fundListCommon } from '@/api/finance.js';
import { roundSimpleList } from '@/api/common';
// import roundSelect from '@/components/base/roundSelect.vue';
import eventEditTable from './components/eventEditTable.vue';

import moment from 'moment';

let validNum = (rule, val, cb) => {
  if (!val || /^\d+\.?\d*$/.test(`${val}`)) {
    cb();
  } else {
    cb(new Error('请输入合法数字'));
  }
};

@Component({
  components: { eventEditTable }
})
class EventConfig extends Vue {
  form: any = {};
  dealType: number | null = null; // 1.新建 2.编辑
  inited: boolean = false;
  eventTypeMap = eventTypeMap;
  eventTypeList = [1, 3, 5].map(key => ({ value: +key, name: eventTypeMap[key] }));
  currencyMap = currencyMap;
  projectId: number | null = null;
  fundList: any[] = [];
  editEventData: any = {};
  id: any = null;
  type: any = 'detail';
  columnsCanEdit: any[] = ['eventClassOfShareId', 'eventNature', 'eventFundId', 'eventCurrency', 'eventAmount', 'eventShareNum', 'eventTotalShareNum'];
  columns: any[] = changedInvestColumns;
  dealDataRaw: any[] = []; // 原始的所有数据
  dealData: any[] = []; // 修改后的所有数据(filter都是基于这个)
  dealDataTable: any[] = []; // table数据(只展示选中行的)
  cacheData: any[] = []; // 暂存数据，用于取消修改时重新填充
  editingKey: string = '';

  rules: any = {
    eventType: [{ required: true, message: '请选择事件类型', trigger: 'blur' }],
    happenDate: [{ required: true, message: '请选择事件发生时间', trigger: 'change' }],
    effectDate: [{ required: true, message: '请选择生效时间', trigger: 'change' }],
    typeRemark: [{ required: true, message: '请输入事件名称', trigger: 'blur' }],
    migrateType: [{ required: true, message: '请选择是否将本项目信息迁移至新项目', trigger: 'change' }],
    investId: [{ required: true, message: '请勾选涉及的历史交易', trigger: 'blur' }]
  };

  companyList: any[] = [];
  companyTotal: number = 0;

  companySelected: any = {};

  layout1 = { labelCol: { span: 5 }, wrapperCol: { span: 18 } };
  layout2 = { labelCol: { span: 20 }, wrapperCol: { span: 19 } };
  layout3 = { labelCol: { span: 20 }, wrapperCol: { span: 19 } };
  layout4 = { labelCol: { span: 20 }, wrapperCol: { span: 21 } };

  IPOFormItem: any[] = [
    {
      key: 'exchange',
      label: '交易所',
      type: 'string'
    },
    {
      key: 'plate',
      label: '板块',
      type: 'string'
    },
    {
      key: 'stockShortName',
      label: '股票简称',
      type: 'string'
    },
    {
      key: 'stockCode',
      label: '股票代码',
      type: 'string'
    },
    {
      key: 'issuePrice',
      label: '发行价',
      type: 'number',
      step: 0.01,
      placeholder: '保留两位小数'
    },
    {
      key: 'lockinPeriod',
      label: '锁定期（单位为天）',
      type: 'number',
      step: 0.1,
      placeholder: '保留一位小数'
    },
    {
      key: 'releasePeriod',
      label: '解禁期',
      type: 'date'
    },
    {
      key: 'ourBoard',
      label: '董事会席位',
      type: 'string'
    },
    {
      key: 'valuationMethod',
      label: '估值方式',
      type: 'string'
    },
    {
      key: 'valuationDiscountRate',
      label: '估值用折扣率',
      type: 'number',
      step: 0.0001,
      placeholder: '保留四位小数'
    }
  ];

  radioStyle: object = {
    display: 'block',
    height: '30px',
    lineHeight: '30px'
  };

  reorganizationFormItem: any[] = [
    {
      // 【重组原因、重组对价、及过程简要描述】（restructureDescription）
      key: 'restructureDescription',
      label: '重组原因、重组对价、及过程简要描述',
      type: 'string'
    }
  ];
  otherFormItem: any[] = [
    {
      // 事件原因及过程简要描述（eventDescription）
      key: 'typeRemark',
      label: '事件名称',
      type: 'string'
    },
    {
      // 事件原因及过程简要描述（eventDescription）
      key: 'eventDescription',
      label: '事件原因及过程简要描述',
      type: 'string'
    }
  ];

  selectedInvestList: any[] = [];

  @Prop()
  visible;

  get detail() {
    return this.$store.state.middlePageDetail.detail;
  }

  get title() {
    return this.dealType === 1 ? '新增公司事件' : '编辑公司事件';
  }

  get dealList() {
    return this.$store.state.middlePageDetail.invest.map(_ => {
      return {
        label: `${_.dealId}${_.classOfShare ? '-' + _.classOfShare : ''}-${_.deliveryDate}-${_.fund.name}`,
        id: _.id,
        dealId: _.dealId
      };
    });
  }

  get state() {
    return this.$store.state.middlePageDetail;
  }

  get companyListWithSelected() {
    // 如果companyList里没有编辑的事件选中的公司，就把选中的这个拼进去
    let res =
      this.dealType === 2 && this.companySelected.projectId && !this.companyList.find(_ => _.projectId === this.companySelected.projectId)
        ? this.companyList.concat(this.companySelected)
        : this.companyList;
    return res;
  }

  async created() {
    // this.getRoundList();
    this.fetchCompanyList('');
    let { projectId, id } = this.$route.query;
    this.projectId = +projectId;
    this.id = id;
    this.type = 'detail';
    await this.fetchDetail();

    this.dealType = id ? 2 : 1;
    let { effectDate, happenDate, releasePeriod, type, sourceTradeIds, newCompanyId, newCompanyName } = this.editEventData || {};
    await this.fetchFundList();
    this.form = {
      ...this.editEventData,
      effectDate: effectDate ? moment(effectDate) : null,
      happenDate: happenDate ? moment(happenDate) : null,
      releasePeriod: releasePeriod ? moment(releasePeriod) : null,
      eventType: type ? type : undefined,
      investId: sourceTradeIds ? sourceTradeIds.split(',').map(Number) : []
    };
    this.dealType === 2 && this.handleInvestChange(sourceTradeIds.split(',').map(Number));
    this.dealType === 2 &&
      newCompanyId &&
      newCompanyName &&
      (this.companySelected = {
        projectId: newCompanyId,
        shortName: newCompanyName
      });
    // dealData需要和historyTradeImpacts拼一下
    this.editEventData.historyTradeImpacts.forEach(_ => {
      let tmp = this.dealData.find(e => e.dealId === _.sourceTradeId);
      if (tmp) {
        Object.keys(_).forEach(e2 => {
          tmp[e2] = _[e2];
        });
      }
    });
    this.cacheData = this.dealData.map(item => ({ ...item }));

    this.$nextTick(() => {
      this.inited = true; //避免初次赋值触发watch
    });
  }

  @Watch('form.eventType')
  eventTypeChange(val) {
    if (val === 5) {
      this.rules['typeRemark'] = { required: true, message: '请输入事件名称', trigger: 'blur' };
    } else {
      delete this.rules.typeRemark;
    }
    //@ts-ignore
    this.$refs.form && this.$refs.form.clearValidate();
  }

  @Watch('form.migrateType')
  migrateTypeChange(val) {
    if (val === 1) {
      this.form.newCompanyId = undefined;
    }
  }

  @Watch('state.invest')
  initDeal(dataList) {
    dataList = this.handleDeal(dataList);
    console.log('dataList', dataList);

    this.dealDataRaw = dataList;
    this.dealData = dataList.map(item => {
      let tmp = { ...item };
      // 把相应字段初始化成''
      for (let i = 0; i < this.columnsCanEdit.length; i++) {
        const key = this.columnsCanEdit[i];
        tmp[key] = tmp[key] ? tmp[key] : '';
      }
      return {
        ...tmp
      };
    });
    this.dealDataTable = this.dealData.filter(_ => this.selectedInvestList.indexOf(_.dealId) > -1);
    this.cacheData = this.dealData.map(item => ({ ...item }));
    console.log('dealDataTable', this.dealDataTable);
  }

  get dealDataTableWithSum() {
    let res =
      this.dealDataTable.length > 0
        ? this.dealDataTable.reduce(
          (_, sum) => {
            let amount = +_['amount'] + +sum['amount'];
            let shareNum = +_['shareNum'] + +sum['shareNum'];
            let totalShareNum = +_['totalShareNum'] + +sum['totalShareNum']; // 企业总股数

            return {
              dealId: '小计',
              amount, // 实际投资金额
              amountText: permil(amount),
              shareNum, // 持有股数
              shareNumText: permil(shareNum, 2, true),
              eventAmount: +_['eventAmount'] + +sum['eventAmount'], // 发生后持有部分成本
              eventShareNum: +_['eventShareNum'] + +sum['eventShareNum'], // 发生后持有股数
              eventTotalShareNum: +_['eventTotalShareNum'] + +sum['eventTotalShareNum'], // 发生后总股数
              totalShareNum
            };
          },
          {
            dealId: '小计',
            amount: 0,
            shareNum: 0,
            eventAmount: 0,
            eventShareNum: 0,
            eventTotalShareNum: 0,
            totalShareNum: 0
          }
        )
        : {};
    res['rowType'] = 'edit';
    return this.dealDataTable.length > 0 ? this.dealDataTable.concat(res) : this.dealDataTable;
  }

  get priceSame() {
    let { shareUnitPrice, dealUnitPrice } = this.form;
    return !(+shareUnitPrice && +dealUnitPrice && +shareUnitPrice !== +dealUnitPrice);
  }

  async fetchDetail() {
    try {
      let { projectId, id, type } = this;
      this.$store.commit('middlePageDetail/setProjectId', projectId);
      this.$store.commit('middlePageSlice/setProjectId', projectId);
      await this.$store.dispatch('middlePageDetail/fetchDetail');
      await this.$store.dispatch('middlePageSlice/fetchSlice');

      if (id) {
        this.editEventData = this.$store.state.middlePageDetail.events.find(_ => _.id === +id);
      }
    } catch (e) {}
  }

  handleDeal(dataList) {
    let {
      detail: { canAuth, canModify, auditDate }
    } = this.state;
    dataList.forEach(data => {
      let {
        dealType,
        currency,
        preValuation,
        postValuation,
        totalShareNum,
        updateTime,
        effectDate,
        deliveryDate,
        amount,
        shareNum,
        shareUnitPrice,
        valuationCurrency,
        thisShareUnitPrice
      } = data;
      data.dealTypeText = dealTypeMap[dealType];
      data.currencyText = currencyMap[currency];
      data.valuationCurrencyText = currencyMap[valuationCurrency];
      data.preValuationText = permil(preValuation);
      data.postValuationText = permil(postValuation);
      data.amountText = permil(amount);
      data.shareNumText = permil(shareNum, 2, true);
      data.shareRatio = +totalShareNum ? permil((shareNum / totalShareNum) * 100, 2) + '%' : '';
      data.unitPriceText = +shareNum ? permil(amount / shareNum, 2) : '';
      data.shareUnitPriceText = permil(shareUnitPrice, 2);
      data.thisShareUnitPriceText = permil(thisShareUnitPrice, 2);

      data.totalShareNumText = permil(totalShareNum, 2, true);
      data.updateTimeText = dateString(updateTime, { showHours: true, char: '.' });
      data.effectDateText = moment(effectDate).format('YYYY.MM.DD');
      data.deliveryDateText = dateString(deliveryDate, { char: '.' });
      data.canModify = canModify;
    });
    return dataList;
  }

  async fetchFundList() {
    try {
      let res = (await fundListCommon().then()) || {};
      this.fundList = res.data || [];
    } catch (e) {}
  }

  deliveryDateChange(val) {
    this.form.effectDate = val;
  }

  handleInvestChange(value) {
    // console.log(value);
    this.selectedInvestList = value;
    // 表格数据也要跟着变
    this.dealDataTable = this.dealData.filter(_ => this.selectedInvestList.indexOf(_.dealId) > -1);
  }

  handleOk() {
    //@ts-ignore
    this.$refs.form.validate(async valid => {
      if (valid) {
        let title = `确认提交数据？`;
        this.$confirm({
          title,
          content: `该事件生效时间为：${this.form.effectDate.format('YYYY-MM-DD')}`,
          okText: '确定',
          okType: 'danger',
          cancelText: '返回修改',
          icon: 'exclamation-circle',
          width: 600,

          onOk: () => {
            this.save();
          }
        });
      } else {
        this.$message.error('请填写完整事件信息');
      }
    });
  }

  formatNum(value, step) {
    if (step === 0.1) {
      return `${value}`
        .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') // 保留小数位
        .replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ','); // 加千分位
    } else if (step === 0.01) {
      return `${value}`.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
    } else if (step === 0.0001) {
      return `${value}`.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3').replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return `${value}`.replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  parseNum(value) {
    return value.replace(/\$\s?|(,*)/g, '');
  }

  async save() {
    let { projectId, id, dealType } = this;
    let { eventType: type, happenDate, effectDate, remark, migrateType, newCompanyId = undefined } = this.form;
    let body = {
      companyId: projectId,
      dealType,
      type,
      happenDate: happenDate.format('YYYYMMDD'),
      effectDate: effectDate.format('YYYYMMDD'),
      remark,
      migrateType,
      newCompanyId,
      sourceTradeIds: this.selectedInvestList.join(',')
    };
    if (dealType === 2) {
      body['id'] = id;
    }
    // 每种type加单独的字段
    if (type === 1) {
      this.IPOFormItem.forEach(_ => {
        if (this.form[_.key]) {
          body[_.key] = _.type === 'date' ? this.form[_.key].format('YYYYMMDD') : this.form[_.key];
        }
      });
    } else if (type === 3) {
      this.reorganizationFormItem.forEach(_ => {
        if (this.form[_.key]) {
          body[_.key] = this.form[_.key];
        }
      });
    } else if (type === 5) {
      this.otherFormItem.forEach(_ => {
        if (this.form[_.key]) {
          body[_.key] = this.form[_.key];
        }
      });
    }
    // 加historyTradeImpacts
    body['historyTradeImpacts'] = this.dealDataTable.map(_ => {
      let res = {
        sourceTradeId: _.dealId
      };
      Object.keys(_).forEach(key => {
        if (this.columnsCanEdit.indexOf(key) > -1) {
          res[key] = _[key];
        }
      });
      console.log(_);

      if (_.eventTradeId) {
        res['eventTradeId'] = _.eventTradeId;
      }
      return {
        ...res
      };
    });

    try {
      let res = await dealEvent(body);
      if (res.code === 200) {
        this.$success({
          title: '提交成功',
          content: `记录提交成功`,
          okText: '确定',
          onOk: () => {
            this.toMiddlePage();
          }
        });
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  handleCancel() {
    //@ts-ignore
    this.$refs.form.clearValidate();
    this.$confirm({
      title: '取消提醒',
      content: '编辑的内容还未保存,确定取消编辑?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.toMiddlePage();
      }
    });
  }

  handleDel() {
    this.$confirm({
      title: '删除提醒',
      content: '将会删除此条记录,确定删除?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.delete();
      }
    });
  }

  async delete() {
    try {
      let { projectId, id } = this;
      let res = await dealEvent({
        id,
        dealType: 3
      });
      if (res.code === 200) {
        this.$message.success('删除成功');
        this.toMiddlePage();
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  async fetchCompanyList(searchName) {
    try {
      let res = await projectListQuery({
        projectStatus: 0,
        pageSize: 50,
        searchName
      });
      let { data = {} } = res || {};
      let { list = [], total } = data;
      list.forEach(_ => (_.financePeopleName = (_.financeUsers || []).map(user => user.userName).join(',')));
      this.companyList = list;
      // 如果companyList里没有目前选的项目的话，就把目前的填进去
      this.companyTotal = total;
    } catch (e) {}
  }

  toMiddlePage() {
    localStorage.setItem('handleSubmit', new Date().getTime().toString());
    if (this.type === 'slice') {
      this.$router.push({ path: '/finance/middlePage/historySlice', query: { projectId: this.projectId + '' } });
    } else {
      this.$router.push({ path: '/finance/middlePage/detail', query: { projectId: this.projectId + '' } });
    }
  }

  // 表格数据编辑变化
  handleChange(value, id, column) {
    // console.log('change',value,id);
    const newData = [...this.dealDataTable];
    const target = newData.find(item => id === item.id);
    if (target) {
      if (column === 'eventFundId') {
        target['eventFundId'] = value;
        let fund = this.fundList.find(_ => _.fundId === value);
        if (fund) {
          target['eventCurrency'] = fund.currency;
        }
      } else {
        target[column] = value;
      }
      this.dealDataTable = newData;
    }
  }

  // 点表格行的编辑
  tableRawEdit(id) {
    const newData = [...this.dealDataTable];
    const target = newData.find(item => id === item.id);
    this.editingKey = id + '';
    if (target) {
      target.editable = true;
      this.dealDataTable = newData;
    }
  }

  tableRowSave(id) {
    const newData = [...this.dealDataTable];
    const newCacheData = [...this.cacheData];
    const target = newData.find(item => id === item.id);
    const targetCache = newCacheData.find(item => id === item.id);
    if (target && targetCache) {
      delete target.editable;
      this.dealDataTable = newData;
      Object.assign(targetCache, target);
      this.cacheData = newCacheData;
    }
    this.editingKey = '';
  }

  tableRawCancel(id) {
    const newData = [...this.dealDataTable];
    const target = newData.find(item => id === item.id);
    this.editingKey = '';
    if (target) {
      Object.assign(
        target,
        this.cacheData.find(item => id === item.id)
      );
      delete target.editable;
      this.dealDataTable = newData;
    }
  }
}

export default EventConfig;
